import AsyncView from '@pixelunion/shopify-asyncview';
import morphdom from 'morphdom';
import rimg from '@pixelunion/rimg-shopify';
import CartItem from './CartItem';

class MonoCart {
  constructor() {
    this.carts = [];
  }

  addCart(el, postMessage) {
    const cartItemEls = el.querySelectorAll('[data-cart-item]');
    const cartItems = [];
    this.postMessage = postMessage;

    cartItemEls.forEach(cartItemEl => cartItems.push(new CartItem(cartItemEl, this.update.bind(this))));

    this.carts.push({
      el,
      cartItems,
    });
  }

  update() {
    return AsyncView.load(
      window.Theme.routes.cart_url,
      { view: 'ajax' },
    ).then(({ html, data }) => {
      this.postMessage('cart:update', data);
      this.carts.forEach((cart) => {
        cart.cartItems.forEach(cartItem => cartItem.unload());
        cart.cartItems = [];

        const cartElements = [
          {
            containers: cart.el.querySelectorAll('[data-cart-items]'),
            html: html.cart_items,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-discounts]'),
            html: html.cart_discounts,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-discounts-simplified]'),
            html: html.cart_discounts_simplified,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-subtotal]'),
            html: html.cart_subtotal,
          },
        ];

        cartElements.forEach(({ containers, html }) => {
          for (let i = 0; i < containers.length; i++) {
            const container = containers[i];
            const virtualContainer = document.createElement('div');

            virtualContainer.innerHTML = html;

            morphdom(
              container,
              virtualContainer,
              {
                childrenOnly: true,
                onBeforeElUpdated: (fromEl, toEl) => {
                  // Skip images if src matches
                  // - we don't want to reload lazy loaded images
                  if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                    return false;
                  }

                  return true;
                },
              },
            );

            const cartItemEls = container.querySelectorAll('[data-cart-item]');
            cartItemEls.forEach(cartItemEl => cart.cartItems.push(new CartItem(cartItemEl, this.update.bind(this))));

            rimg.watch(container);
          }
        });

        return data;
      });
    });
  }

  unload() {
    this.carts.forEach((cart) => {
      cart.cartItems.forEach(cartItem => cartItem.unload());
    });
    this.carts = [];
  }
}

export default new MonoCart();
